import React from 'react'
import InputField from 'src/components/common/Inputfield'
import { CustomerEligibilityV2Type, DiscountPrerequisite } from 'src/lib/types/discountsV2'
import { useLocale } from 'src/lib/hooks/useLocal'
import FormErrorText from 'src/components/common/FormErrorText'
import { CustomerEligibilityOptions, CustomerEligibilityStateType } from 'src/lib/types/common/customerConditions'
import { FlowErrorType } from 'src/lib/types/common/error'

interface LifetimeOrderCountProps {
  state: Extract<CustomerEligibilityStateType, { type: CustomerEligibilityOptions.LIFETIME_ORDER_COUNT }>
  onChange: (value: CustomerEligibilityStateType) => void
  errors?: {
    minimumOrders?: FlowErrorType
    maximumOrders?: FlowErrorType
  }
}

const LifetimeOrderCount: React.FC<LifetimeOrderCountProps> = ({ state, onChange, errors }) => {
  const { t } = useLocale()

  if (state.type !== CustomerEligibilityOptions.LIFETIME_ORDER_COUNT) {
    return null
  }

  const handleCohortChange = (field: 'minimumOrders' | 'maximumOrders', value: string) => {
    if (field === 'maximumOrders') {
      onChange({
        ...state,
        maximumOrders: parseInt(value) || null
      })
    } else {
      onChange({
        ...state,
        minimumOrders: parseInt(value) || 0
      })
    }
  }

  return (
    <div className='pb-2 w-full flex flex-col'>
      <div className='pt-1 pb-4 border-b border-dotted border-zinc-200 w-full'>
        <div className='w-[60%] flex shrink-0 gap-4'>
          <div className='flex-1 '>
            <InputField
              id='lifetime-min-order-count'
              label={t('discounts_v2.minimum')}
              type='number'
              variant='filled'
              value={state.minimumOrders || ''}
              onChange={val => handleCohortChange('minimumOrders', val)}
              error={errors?.minimumOrders?.message}
            />
          </div>
          <div className='flex-1'>
            <InputField
              id='lifetime-max-order-count'
              label={t('discounts_v2.maximum_optional')}
              placeholder={t('discounts_v2.no_limit')}
              type='number'
              variant='filled'
              value={state.maximumOrders ?? ''}
              onChange={val => handleCohortChange('maximumOrders', val)}
            />
          </div>
        </div>
        <FormErrorText message={errors?.minimumOrders?.message || errors?.maximumOrders?.message} />
      </div>
    </div>
  )
}

export default LifetimeOrderCount
